import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=068d1c66&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=ts&"
export * from "./Navigation.vue?vue&type=script&lang=ts&"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=068d1c66&scoped=true&lang=css&"
import style1 from "./Navigation.vue?vue&type=style&index=1&id=068d1c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068d1c66",
  null
  
)

export default component.exports